import React from 'react';
import HeroSection from '../home/HeroSection';
import HighlightsSection from '../home/HighlightsSection';
import ProductShowcase from '../home/ProductShowcase';
import BentoGrid from '../home/BentoGrid';
import ComparisonSection from '../home/ComparisonSection';
import SpecificationsSection from '../home/SpecificationsSection';
import CallToAction from '../home/CallToAction';
import './Home.css';

/**
 * PeaceMobiles Flagship Home Page
 * Built with Apple design principles:
 * - High contrast titanium metallic typography
 * - Full-viewport immersive hero
 * - Scroll-triggered micro-animations & reveals
 * - Interactive Bento-box feature matrix
 * - Dynamic finish/color selector
 * - Complete model comparison & specs
 */
const Home = () => {
  return (
    <div className="apple-home-root">
      {/* 1. Full Viewport Hero Section */}
      <HeroSection />

      {/* 2. Key Innovation Highlights Carousel */}
      <HighlightsSection />

      {/* 3. Interactive Color & Finish Showcase */}
      <ProductShowcase />

      {/* 4. Bento-Box Feature Matrix */}
      <BentoGrid />

      {/* 5. Comprehensive Model Comparison */}
      <ComparisonSection />

      {/* 6. Technical Specifications Accordion */}
      <SpecificationsSection />

      {/* 7. Closing Buy & Trade-in Call to Action */}
      <CallToAction />
    </div>
  );
};

export default Home;